
export default {
    namespaced: true,
    state: {
        outlineNodes: []
    },
    mutations: {
        SET_OUTLINE_NODES: (state, list) => {
            state.outlineNodes = list;
        }
    }
};